import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import MarketplacePage from "@/pages/MarketplacePage";
import ListingDetailPage from "@/pages/ListingDetailPage";
import CatalogPage from "@/pages/CatalogPage";
import PublishPage from "@/pages/PublishPage";
import AdminPage from "@/pages/AdminPage";
import MyListingsPage from "@/pages/MyListingsPage";
import ServiceRequestPage from "@/pages/ServiceRequestPage";
import AdminServiceRequestsPage from "@/pages/AdminServiceRequestsPage";
import AdminConfigPage from "@/pages/AdminConfigPage";
import AdminCatalogPage from "@/pages/AdminCatalogPage";
import FavoritesPage from "@/pages/FavoritesPage";
import MedicineRequestPage from "@/pages/MedicineRequestPage";
import MedicineRequestsListPage from "@/pages/MedicineRequestsListPage";

export default function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-slate-50">
      <AuthProvider>
        <FavoritesProvider>
          <BrowserRouter>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/medicamentos" element={<MarketplacePage />} />
              <Route path="/medicamento/:id" element={<ListingDetailPage />} />
              <Route path="/catalogo" element={<CatalogPage />} />
              <Route path="/busquedas" element={<MedicineRequestsListPage />} />
              <Route
                path="/buscar-medicamento"
                element={
                  <ProtectedRoute>
                    <MedicineRequestPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/servicios" element={<ServiceRequestPage />} />
              <Route
                path="/ofrecer"
                element={
                  <ProtectedRoute>
                    <PublishPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ofrecer/:id"
                element={
                  <ProtectedRoute>
                    <PublishPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mis-publicaciones"
                element={
                  <ProtectedRoute>
                    <MyListingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/favoritos"
                element={
                  <ProtectedRoute>
                    <FavoritesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/servicios"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminServiceRequestsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/config"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminConfigPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/catalogo"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminCatalogPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
          <Toaster richColors position="top-right" />
          </BrowserRouter>
        </FavoritesProvider>
      </AuthProvider>
    </div>
  );
}
